import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { MeterModelService } from '../../service/meter-type.service';
import { getMeterNameText, MeterMediaType, MeterMediaTypeSelection } from '../../model/const/enums';
import { SelectionItem } from '../../../core/component/select/select.component';
import { Subscription } from 'rxjs';
import { MeterService } from '../../service/meter.service';

@Component({
    selector: 'app-create-meter-dialog-form',
    templateUrl: './create-meter-dialog-form.component.html',
    styleUrls: ['./create-meter-dialog-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CreateMeterDialogFormComponent implements OnInit, OnDestroy {
  constructor(
    private _dialogService: ActionWindowService,
    private _meterService: MeterService,
    private _fb: FormBuilder,
    private _fc: FormControlExFactory
  ) {}

  @Input() dataContext: {
    meterType: MeterMediaType;
    modelSelection: SelectionItem[];
    propertyId: string;
  };

  form: FormGroup;

  cancel() {
    this._dialogService.close();
  }

  meterTypeSelection: SelectionItem[];

  ngOnInit() {
    this.meterTypeSelection = MeterMediaTypeSelection;
    this.form = this._fb.group({
      meterType: this._fc.createReadonly('CONSUMPTION.MEDIA_TYPE.TYPE', this.dataContext.meterType),
      name: this._fc.createMandatory(getMeterNameText(this.dataContext.meterType), ''),
      propertyId: this._fc.createHidden(this.dataContext.propertyId),
      imdMeterModelId: this._fc.create('CONSUMPTION.METER_MODEL.METER_MODEL', ''),
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  private sub: Subscription;
  submitEnabled = true;
  onSubmit() {
    if (this.form.invalid || !this.submitEnabled) {
      return;
    }
    this.submitEnabled = false;
    if (this.sub) {
      this.sub.unsubscribe();
    }
    this.sub = this._meterService.add(this.form.value, { notifyUser: false }).subscribe(model => {
      model.imdMeterModelId = this.form.controls['imdMeterModelId'].value;
      this._dialogService.complete(model);
    });
  }
}
